module.exports = __webpack_public_path__ + "static/media/3DPPA7.98f1786d.jpg";